import React from 'react';
import { withTranslate } from 'react-admin';
import { ChangelogPanel } from '~/components/Changelog';
import DraftPanel from '~/components/Drafts/DraftPanel';
import PendingCaseNotice from '~/components/Approvals/PendingCaseNotice';
import ProfileData from './ProfileData';
import { useRecordTitleStyles } from './styles';
import { RecordTitleProps } from './types';

const RecordTitle = (props: RecordTitleProps) => {
  const { record } = props;
  const classes = useRecordTitleStyles();

  if (!record) {
    return <div />;
  }

  return (
    <div className={classes.gridContainer}>
      <ProfileData {...props} />
      {props.hasPathnameProfile && <ChangelogPanel />}
      <PendingCaseNotice />
      <DraftPanel record={record} />
    </div>
  );
};

export default withTranslate(RecordTitle);
